import type * as React from 'react';
import { cn } from '@/lib/utils';
import { MockBanner } from '@/components/ui/MockBanner';

interface PageHeaderProps {
  title: string;
  description?: string;
  actions?: React.ReactNode;
  breadcrumbs?: React.ReactNode;
  mock?: boolean;
  className?: string;
}

function PageHeader({ title, description, actions, breadcrumbs, mock = false, className }: PageHeaderProps) {
  return (
    <div className={cn('space-y-2', className)}>
      {/* Breadcrumbs row */}
      {breadcrumbs && <div className="mb-2">{breadcrumbs}</div>}

      {/* Title + Actions row */}
      <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
        <div className="flex items-center gap-2.5">
          <h1 className="text-2xl font-bold text-raios-text">{title}</h1>
          {mock && <MockBanner />}
        </div>
        {actions && (
          <div className="flex items-center gap-2 shrink-0">{actions}</div>
        )}
      </div>

      {/* Description */}
      {description && (
        <p className="text-sm text-raios-muted mt-1">{description}</p>
      )}
    </div>
  );
}

PageHeader.displayName = 'PageHeader';

export { PageHeader };
export type { PageHeaderProps };
